/**
 * This file is generated from scripts/genIconComponents.ts. Any
 * changes should be made in that file.
 */
import { color as colorFn } from "@smartsheet/design-tokens-react";
import React, { CSSProperties, forwardRef, Ref } from "react";
import { GeneratedIconProps } from "../../components/icon/GeneratedIconProps";
import { Icon } from "../../components/icon/Icon";
import { getUrsaIconColorVarName } from "../../components/icon/getUrsaIconColorVarName";
import ChevronRightLineIcon16 from "./ChevronRightLineIcon16";
import ChevronRightLineIcon20 from "./ChevronRightLineIcon20";
import ChevronRightLineIcon24 from "./ChevronRightLineIcon24";

const getSizeMap = (viewBox?: string, width?: string | number, height?: string | number) => {
    return {
        16: viewBox ? (
            <ChevronRightLineIcon16 viewBox={viewBox} width={width ? width : 16} height={height ? height : 16} />
        ) : (
            <ChevronRightLineIcon16 width={width ? width : 16} height={height ? height : 16} />
        ),
        20: viewBox ? (
            <ChevronRightLineIcon20 viewBox={viewBox} width={width ? width : 20} height={height ? height : 20} />
        ) : (
            <ChevronRightLineIcon20 width={width ? width : 20} height={height ? height : 20} />
        ),
        24: viewBox ? (
            <ChevronRightLineIcon24 viewBox={viewBox} width={width ? width : 24} height={height ? height : 24} />
        ) : (
            <ChevronRightLineIcon24 width={width ? width : 24} height={height ? height : 24} />
        ),
    };
};

export interface ChevronRightLineIconProps extends GeneratedIconProps {
    /**
     * The size to render the icon at.
     */
    size: 16 | 20 | 24;
}

export const ChevronRightLineIcon = forwardRef(
    (
        {
            // This is the default icon color.
            color = `var(${getUrsaIconColorVarName()}, ${colorFn("color--icons--neutral--strongest")})`,
            size,
            viewBox,
            width,
            height,
            style,

            ...rest
        }: ChevronRightLineIconProps,
        ref: Ref<HTMLElement>
    ) => {
        return (
            <Icon
                color={color}
                ref={ref}
                size={size}
                width={width}
                height={height}
                {...rest}
                style={
                    {
                        ...style,
                    } as CSSProperties
                }
            >
                {getSizeMap(viewBox, width, height)[size]}
            </Icon>
        );
    }
);
ChevronRightLineIcon.displayName = "ChevronRightLineIcon";
